import React, { useMemo, useState } from 'react';
import { UpsellList } from '../elements';
import { ProductOffer } from '../ProductOffer';
import ServiceOffer from '../ServiceOffer';
import SmartUpsellProductOffer from '../SmartUpsellProductOffer';
import { Boundary } from '../../components/ErrorBoundary';
import { AddButtonAction, ButtonAction, Offer, Product } from '../../types';
import { useProductsContext } from '../../contexts/ProductsContext';
import { useSharedContext } from '../../contexts/SharedContext';
import { REGISTERED_APPS } from '../../shared/types/Apps';

interface Props {
  offers: Offer[];
  currency: string;
  handleAddToCart: (
    offer: Offer,
    product?: Product,
    action?: AddButtonAction,
  ) => Promise<boolean>;
  handleRemoveFromCart: (offer: Offer) => Promise<void>;
  parentProduct?: Product;
  currentApp: REGISTERED_APPS;
  onClose: (
    ignoreUpgrade?: boolean,
    closeAction?: ButtonAction,
  ) => Promise<void>;
}

const UpsellOffers = ({
  offers,
  parentProduct,
  handleAddToCart,
  ...restProps
}: Props) => {
  const { selectedProduct } = useProductsContext();
  const { runningAppName } = useSharedContext();
  const [smartOfferIndex, setSmartOfferIndex] = useState(-1);

  const smartOffers = useMemo(
    () =>
      offers.filter((offer, index) => {
        if (
          offer.is_product &&
          offer.use_recommended_products &&
          offer.recommended_product_count
        ) {
          setSmartOfferIndex((prevIndex) =>
            prevIndex > -1 ? prevIndex : index,
          );
          return true;
        }
        return false;
      }),
    [offers],
  );

  return (
    <UpsellList
      offerCount={offers.length}
      isProductSelected={!!selectedProduct}
    >
      {offers.map((offer, index) => {
        const isProductOffer =
          offer.is_product && !offer.use_recommended_products;
        const isServiceOffer = !offer.is_product;

        return (
          <Boundary key={offer.id} app={runningAppName}>
            {smartOffers.length > 0 && index === smartOfferIndex && (
              <SmartUpsellProductOffer
                smartOffers={smartOffers}
                offers={offers}
                offerCount={offers.length}
                parentProduct={parentProduct}
                handleAddToCart={handleAddToCart}
                {...restProps}
              />
            )}
            {isProductOffer && (
              <ProductOffer
                offer={offer}
                offerCount={offers.length}
                parentProduct={parentProduct}
                indexInOffers={index}
                handleAddToCart={handleAddToCart}
                {...restProps}
              />
            )}
            {isServiceOffer && (
              <ServiceOffer
                offer={offer}
                offerCount={offers.length}
                indexInOffers={index}
                handleAddToCart={handleAddToCart}
                {...restProps}
              />
            )}
          </Boundary>
        );
      })}
    </UpsellList>
  );
};
export default UpsellOffers;
